import { Component } from '@angular/core';
import { Guard } from 'app/core/services/guard.service';

@Component({
    selector: 'itpx-approvals-dashboard',
    templateUrl: './approvals-dashboard.component.html'
})
export class ApprovalsDashboardComponent {
    tiles: Array<any> = [
        {
            title: 'Approval Rules',
            redirectPath: 'approved-rules',
            description: 'Create & Manage Approval Rules',
            icon: 'fa-cog',
            color: 'orange',
            permission: 'buyerAdminApproval'
        },
        {
            title: 'Transaction Approvals',
            redirectPath: 'transaction-approvals',
            description: 'Manage Your Transactions Approvals',
            icon: 'fa-file-check',
            color: 'orange',
            permission: 'buyerGeneralApproval'
        },
        {
            title: 'Consumption Requests Approvals',
            redirectPath: 'consumption-requests-approvals',
            description: 'Manage Your Consumption Requests Approvals',
            icon: 'fa-book-open',
            color: 'orange',
            permission: 'buyerGeneralApproval'
        },
    ];

    constructor(
        public guard: Guard
    ) { }
}



// WEBPACK FOOTER //
// ./src/app/organization/components/approvals/dashboard/approvals-dashboard.component.ts